import { h, JSX } from "preact";

import "./fab.scss";

import { useState } from "preact/hooks";
import { Plus } from "preact-feather";

export default function Fab({
   icon,
   items,
}: {
   icon: JSX.Element;
   items: { icon: JSX.Element; onClick: () => void; label?: string }[];
}) {
   const [open, setOpen] = useState(false);

   return (
      <div class="cfab">
         <a
            class="elv-16 btn btn-primary"
            // style="color:white;"
            style={{
               transform: open ? "rotateZ(135deg)" : undefined,
            }}
            aria-label="add"
            onClick={(evt) =>
               (evt.preventDefault() as any) || setOpen((o) => !o)
            }
         >
            {icon}
         </a>
         <ul class={open ? "visible" : ""}>
            {items.map((i) => (
               <li>
                  <a
                     class="elv-16 btn btn-primary"
                     // style="color:white;"
                     aria-label={i.label}
                     onClick={(evt) => {
                        evt.preventDefault();
                        setOpen(false);
                        i.onClick();
                     }}
                  >
                     {i.icon}
                  </a>
               </li>
            ))}
         </ul>
      </div>
   );
}
